/* eslint-disable @typescript-eslint/no-unused-vars */
import { Quaternion, Vector3 } from "babylonjs";
import PoseBase from "./PoseBase";

export default class PoseConstraints extends PoseBase {

  public constraintPositionX?: number;
  public constraintPositionY?: number;
  public constraintPositionZ?: number;

  private _rotation: Vector3 = new Vector3(0, 0, 0);
  public constraintRotationX?: number;
  public constraintRotationY?: number;
  public constraintRotationZ?: number;

  constructor() {
    super();
  }

  public override update() {
    if( this.constraintPositionX ) {
      this.position.x = this.constraintPositionX;
    }
    if( this.constraintPositionY ) {
      this.position.y = this.constraintPositionY;
    }
    if( this.constraintPositionZ ) {
      this.position.z = this.constraintPositionZ;
    }

    if (this.constraintRotationX !== undefined || this.constraintRotationY !== undefined || this.constraintRotationZ !== undefined) {
      this.rotation.toEulerAnglesToRef(this._rotation);

      this._rotation.x = this.constraintRotationX ?? this._rotation.x;
      this._rotation.y = this.constraintRotationY ?? this._rotation.y;
      this._rotation.z = this.constraintRotationZ ?? this._rotation.z;
      
      this.rotation.copyFrom(Quaternion.FromEulerAngles(this._rotation.x, this._rotation.y, this._rotation.z));
    }
  }

  public override reset() {
    super.reset();
    this.constraintPositionX = undefined;
    this.constraintPositionY = undefined;
    this.constraintPositionZ = undefined;

    this.constraintRotationX = undefined;
    this.constraintRotationY = undefined;
    this.constraintRotationZ = undefined;
  }
}